<template>
    <div>
      <report-header @generate="load" @filterChanged="filterChanged"
        @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd" @onChangedGroup="onChangedGroup"
        :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"
        @limitChanged="limitChanged"
        @download="download"
        @onChangeAccsGroup="onChangeAccsGroup"/>

      <basic-table
        @Filtred="Filtred"
        :items="otherCharges"
        :fields="otherChargesFields"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"/>
      <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    </div>
</template>

<script>
import download from '@/utils/downloadFile'
export default {
  props: {
    userId: 0
  },
  data () {
    return {
      getStore: {
        numDateEnd: 0,
        numDateStart: 0,
        userId: 0,
        group_id: 0,
        accs_group_id: 0,
        accounting_period_id: 0,
        account_id: 0,
        limit: 500,
        download: 0
      },
      otherCharges: [],
      otherChargesFields: [
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'full_name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'chargesType', label: this.$i18n.t('Charge type'), sortable: true},
        {key: 'date', label: this.$i18n.t('Time of charge'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'charge',
          label: this.$i18n.t('Volume'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }},
        {key: 'charge_with_tax',
          label: this.$i18n.t('Charge with tax'),
          sortable: true,
          formatter: (val, key, item) => {
            return val.toFixed(2)
          }}
      ],
      isGenerateDisabled: false,
      selectGroup: 0,
      selectAccsGroup: 0,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      filterOptions: {
        isFilterGroup: true,
        isFilterAccsGroup: true,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false,
        isDownloadable: true,
        hasLimitRows: true
      }
    }
  },
  methods: {
    Filtred (items) {
      this.totalRows = items.length
    },
    async load (isGenerateClick = true) {
      this.isGenerateDisabled = true
      let numDateEnd = Number(this.dateEnd) / 1000
      if (numDateEnd > 2147483647) numDateEnd = 2147483647
      let numDateStart = Number(this.dateStart) / 1000
      if (numDateStart > 2147483647) numDateStart = 2147483647
      this.getStore.numDateEnd = numDateEnd
      this.getStore.numDateStart = numDateStart
      if (!this.userId) {
        this.getStore.group_id = this.selectGroup
        this.getStore.accs_group_id = this.selectAccsGroup
      } else {
        this.getStore.userId = this.userId
      }
      await this.$store.dispatch('Reports/GET_OTHER_CHARGES', this.getStore).then(response => {
        if (isGenerateClick) {
          this.otherCharges = this.$store.getters['Reports/OTHER_CHARGES']
          for (let el of this.otherCharges) {
            switch (el.service_type) {
              case 1:
                el.chargesType = this.$i18n.t('One-time service link')
                break
              case 2:
                el.chargesType = this.$i18n.t('Periodic service link')
                break
              case 3:
                el.chargesType = this.$i18n.t('IP traffic service link')
                break
              case 4:
                el.chargesType = this.$i18n.t('Hotspot service link')
                break
              case 5:
                el.chargesType = this.$i18n.t('Dial-up service link')
                break
              case 6:
                el.chargesType = this.$i18n.t('Telephony service link')
                break
              case 7:
                el.chargesType = this.$i18n.t('Separate service link')
                break
              case 8:
                el.chargesType = this.$i18n.t('IPTV service link')
                break
              case 9:
                el.chargesType = this.$i18n.t('Video on demand')
                break
              case 17:
                el.chargesType = this.$i18n.t('Cancel payment')
                break
              case 18:
                el.chargesType = this.$i18n.t('Burnt payment')
                break
              case 20:
                el.chargesType = this.$i18n.t('Balance rollover')
                break
              case 21:
                el.chargesType = this.$i18n.t('Funds flow')
                break
              case 22:
                el.chargesType = this.$i18n.t('Repayment')
                break
              case 24:
                el.chargesType = this.$i18n.t('Tel invoices correction')
                break
            }
          }
        } else {
          download(this.$store.getters['Reports/OTHER_CHARGES'], 'report_payments_other_charges.csv', 'text/csv')
        }

        this.loadDone()
      })
    },
    download () {
      this.getStore.download = 1
      this.load(false)
      this.$store.dispatch('Reports/CLEAR_OTHER_CHARGES')
      this.getStore.download = 0
      this.totalRows = 0
      this.otherCharges = []
    },
    limitChanged (limit) {
      this.getStore.limit = limit
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    onChangedGroup (value) {
      this.selectGroup = (value)
    },
    onChangeAccsGroup (value) {
      this.selectAccsGroup = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
    if (this.userId) {
      this.filterOptions.isFilterGroup = false
      this.filterOptions.isFilterAccsGroup = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/payments/otherCharges/main.vue